export default __webpack_public_path__ + "static/media/flag-full.83ecee08.svg";